import type { Project, ProjectMemberInfo, Projects } from "~/interface/project";

export const SAMPLE_PROJECT_ID = "sample-project-tutorial";

export const sampleProject: Project = {
  id: SAMPLE_PROJECT_ID,
  organization_id: "sample-org",
  name: "【チュートリアル用】サンプルプロジェクト",
  description: "REQXIGNの使い方を学ぶためのサンプルプロジェクトです",
  start_date: "2024-01-01",
  end_date: "2024-03-31",
  modified_at: new Date().toISOString(),
  client: {
    name: "サンプルクライアント",
    url: undefined,
  },
  vocabulary: [],
  outputs: {
    "meeting-minutes": {
      id: "sample-meeting-minutes",
      isGenerating: false,
    },
    knowledge: {
      id: "sample-knowledge",
      isGenerating: false,
    },
    "system-overview": {
      id: "sample-system-overview",
      isGenerating: false,
    },
  },
  meta_prompts: [],
  estimationData: {
    total_cost: 0,
    unit_prices: {
      common: 0,
      app: 0,
      plugin: 0,
      customize: 0,
      external_service: 0,
    },
    work_loads: {
      xl: 0,
      l: 0,
      m: 0,
      s: 0,
      xs: 0,
    },
  },
  editableEstimationData: {
    total_cost: 0,
    unit_prices: {
      common: 0,
      app: 0,
      plugin: 0,
      customize: 0,
      external_service: 0,
    },
    work_loads: {
      xl: 0,
      l: 0,
      m: 0,
      s: 0,
      xs: 0,
    },
  },
  costEffectivenessData: undefined,
};

export const sampleDocuments = {
  "meeting-minutes": {
    id: "sample-meeting-minutes",
    project_id: SAMPLE_PROJECT_ID,
    type: "meeting-minutes",
    title: "サンプル議事録",
    content:
      "# サンプル議事録\n\nこれは議事録のサンプルです。\n\n## 会議の目的\n新しいシステムの要件定義を行う\n\n## 参加者\n- 田中さん\n- 鈴木さん\n\n## 議題\n1. システムの概要\n2. 必要な機能\n3. スケジュール",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  knowledge: {
    id: "sample-knowledge",
    project_id: SAMPLE_PROJECT_ID,
    type: "knowledge",
    title: "サンプルナレッジ",
    content:
      "# サンプルナレッジ\n\nこれはナレッジのサンプルです。\n\n## プロジェクトの背景\n顧客管理システムの構築\n\n## 技術スタック\n- フロントエンド: React\n- バックエンド: Node.js\n- データベース: PostgreSQL",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  "system-overview": {
    id: "sample-system-overview",
    project_id: SAMPLE_PROJECT_ID,
    type: "system-overview",
    title: "サンプルシステム概要書",
    content:
      "# システム概要書\n\nこれはシステム概要書のサンプルです。\n\n## システムの目的\n顧客情報を効率的に管理するシステムの構築\n\n## 主要機能\n1. 顧客登録・編集\n2. 検索機能\n3. レポート出力\n\n## 非機能要件\n- 性能: 100ユーザー同時アクセス対応\n- セキュリティ: SSL/TLS通信",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
};

export const isSampleProject = (projectId: string | undefined): boolean => {
  return projectId === SAMPLE_PROJECT_ID;
};

const sampleProjectMembers: ProjectMemberInfo[] = [
  {
    id: "sample-member-owner",
    organization_id: sampleProject.organization_id,
    project_id: sampleProject.id,
    role: "owner",
    user_id: "tutorial-owner",
  },
  {
    id: "sample-member-viewer",
    organization_id: sampleProject.organization_id,
    project_id: sampleProject.id,
    role: "member",
    user_id: "tutorial-member",
  },
  // 追加: 表示の一貫性のため、サンプルプロジェクトのメンバーを3名にする
  {
    id: "sample-member-contributor",
    organization_id: sampleProject.organization_id,
    project_id: sampleProject.id,
    role: "contributor",
    user_id: "tutorial-contributor",
  },
];

export const sampleProjectsEntry: Projects = {
  project: sampleProject,
  users: sampleProjectMembers,
};
